import CityPageTemplate from "../city-template/CityPageTemplate";
import { rocklandConfig } from "./data";

export default function RocklandPage() {
  return <CityPageTemplate config={rocklandConfig} />;
}